import * as Api from "@api";
import * as C from "@components";

const SmoothEvenHeatingCardContentBaseKey = "smooth-even-heating" as const;
const imageDirectory = `/images/products/@global/cards/`;

export const SmoothEvenHeatingCardContentKeys = [
    `${SmoothEvenHeatingCardContentBaseKey}.headline`,
    `${SmoothEvenHeatingCardContentBaseKey}.body`
] as const;

interface SmoothEvenHeatingCardProps
{
    pageContent: Api.Content<typeof SmoothEvenHeatingCardContentKeys[number]>;
}

export const SmoothEvenHeatingCard = ({ pageContent }: SmoothEvenHeatingCardProps): React.FunctionComponentElement<SmoothEvenHeatingCardProps> =>
    <C.ImageCard {...C.getImageCardStdProps({
        keyBase: SmoothEvenHeatingCardContentBaseKey,
        width: C.Width.W60P,
        pageContent,
        imagePosition: C.CardImagePosition.Top,
        imageAlignment: C.HorizontalAlignment.Right,
        imageWidth: 598,
        imageHeight: 475,
        imageDirectory,
        headingMaxWidth: C.Width.W444,
        bodyMaxWidth: C.Width.W444,
        indentBefore: 60,
        mainAxisOffset: -48,
        mobileImageProps: {
            mobileWidth: 768,
            mobileHeight: 620, 
        }
    })} />
